module.exports = __webpack_public_path__ + "img/SV.3476253b.svg";